import {FoodRequestsIds} from "../ProductsFilterModal/consts.jsx";
import {Images} from "../../images/Images.jsx";

export const FoodRequestToIcon = {
    [FoodRequestsIds.veganFriendly] : Images.veganImage,
    [FoodRequestsIds.vegetarianFriendly] : Images.vegetarianImage,
    [FoodRequestsIds.glutenFree] : Images.glutenFreeImage,
    [FoodRequestsIds.lactoseFree] : Images.lactoseFreeImage,
    [FoodRequestsIds.furOption]: Images.parveImage
}